import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';
import { IntlProvider } from 'react-intl';
import Route from './routes/index';
import * as serviceWorker from './serviceWorker';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
const msalInstance = new PublicClientApplication(msalConfig);
import MetaTags from 'react-meta-tags';
import English from './lang/en.json';
import zhCn from './lang/zh.json';
import * as global from './global'; // Don't remove

let lang;
if (localStorage.getItem('locale') === 'en' || !localStorage.getItem('locale')) {
    lang = English;
} else if (localStorage.getItem('locale') === 'zh') {
    lang = zhCn;
}
moment.tz.setDefault("Asia/Hong_Kong");

function App() {
    return (
        <MsalProvider instance={msalInstance}>
            <MetaTags>
                <meta name="viewport" content="initial-scale=1, maximum-scale=1" />
            </MetaTags>
            <IntlProvider locale={localStorage.getItem('locale')} messages={lang}>
                <Route />
            </IntlProvider>
        </MsalProvider>
    );
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
